import SocketHandler from '@/service/webSocket/socket-handler.js'
export default class B {
    constructor (vm) {
        this.vue = vm
    }

    create (tag, Grocery, option) {
        const that = this
        const data = { ...option, opts$: { ...option.opts$, ...{ handler (ws) {
            const instance = new SocketHandler(tag, ws, that)
            that[tag].h$ = instance
            return { handler: instance }
        } } } }
        this[tag] = new Grocery(data)
        new Array({ tag }, { queue: {}, promisePool: {} }).forEach(fo => this.assignment(tag, fo))
        this.eventMounte(tag)
        return this.next()
    }

    async start (tag, url, cmd, callBack) {
        this.assignment(tag, { url })
        if (this.examination(tag)) {
            await this[tag].websocket.init(url)
            this[tag].h$.collect("socketCode", 1)
            if (this.examination(tag)) {

                await this.catchCallBack(tag, cmd, callBack)

                if (typeof callBack === 'function') {
                    return { nextTo: this.next() }
                }
                return { gen: this[tag].queue[cmd], nextTo: this.next() }
            }
        }
        return { nextTo: this.next() }
    }
   
    async catchPromise (tag, eventName) {
        return new Promise(resolve => ( this[tag].promisePool[eventName] = resolve ))
    }

    async catchCallBack (tag, eventName, eventFunction) {
        return this[tag].promisePool[eventName] = eventFunction
    }

    mappingRequst (tag, stateMsg) {
        const requestId = stateMsg.data.requestId || this.vue.util$.getRandomId$(stateMsg.cmd)
       
        Object.assign(stateMsg.data, { requestId })
        const target = this[tag].store  || {}
        const { ver, customerId, clientId } = target
        stateMsg.data = Object.assign({ ver, customerId, clientId }, stateMsg.data);
        let filterObj = {}
        Object.keys(stateMsg.data).filter(key => {
            return (stateMsg.data[key] || typeof stateMsg.data[key] === 'boolean')
        })
        .forEach(key => {
            filterObj[key] = stateMsg.data[key]
        })
        stateMsg.data = filterObj
        return { stateMsg, requestId }
    }

    async send (tag, stateMsg, callBack, eventObj) {

        const { stateMsg: stateMsgResult, requestId } = this.mappingRequst(tag, stateMsg)

        if (typeof callBack === 'string') {
            const iterator = this.asyncReact()
            this[tag].queue[callBack] = iterator
        } else if (!callBack) {
            const iterator = this.asyncReact()
            this[tag].queue[requestId] = iterator
        }
        
        if (!this[tag].websocket.send) {
            console.log('ding:', this[tag])
        }
        console.log('ding:',this[tag].websocket.send, this[tag], JSON.stringify(stateMsgResult))
        // if (tag === 'rms') return
        await this[tag].websocket.send(JSON.stringify(stateMsgResult))

        if (eventObj) {
            const { eventName, callBack } = eventObj
            this.catchCallBack(tag, eventName, callBack)
        }

        if (typeof callBack === 'string') {
            await this.catchPromise(tag, callBack)
            return Promise.resolve({ gen: this[tag].queue[callBack], nextTo: this.next() })
        }
    
        if (callBack) {
            await this.catchCallBack(tag, requestId, callBack)
            return Promise.resolve({ nextTo: this.next() })
        }

        await this.catchPromise(tag, requestId)
        return Promise.resolve({ gen: this[tag].queue[requestId], nextTo: this.next() })
    }

    sendBinary (tag, config, buffer, progress, MaxMB = 100) {
        let sId = config.sId
        return new Promise((resolve, reject) => {
            const MB = (config.size / (1024 * 1024)).toFixed(2)
            if (MB >= MaxMB) return reject(0)
            this[tag].websocket.sendBinary(JSON.stringify(config), buffer, 1).then(() => {
                this.catchCallBack(tag, sId, progress)
                resolve()
            }).catch(err => {
                reject(err)
            })
        })
    }

    * asyncReact () {
        const res = yield
        yield
        return res
    }

    expressLetter ({ packageLetter, tag, eventName }) {
        const randomId = ((packageLetter.data && packageLetter.data.requestId) || eventName)
        const sId = packageLetter.sid || ""
        const trg = this[tag].promisePool[randomId]
        const iterator = this[tag].queue[randomId]
        iterator && new Array(2).fill('').forEach(() => iterator.next(packageLetter))
        typeof trg === "function" && trg(packageLetter)
        if (sId) {
            let progress = this[tag].promisePool[sId]
            if (typeof progress === "function") {
                progress({ data: packageLetter, eventName: eventName.replace("ws.cmd.", "")})
            }
        }
    }

    eventMounte (tag) {
        const event = this[tag].websocket.events
        event.forEach(eventName => {
            this[tag].websocket.on(eventName, letter => {
                if (!this[tag]) return

                if (eventName === 'ws.message') {
                    const judge = letter.indexOf('update_contact_list') > -1
                    if (judge) {
                       const result = this.vue.util$.toJson$(letter)
                       this[tag].promisePool['ws.cmd.' + result.cmd](result)
                    } else if (this.vue.util$.toJson$(letter).cmd === 'update_robot_code_lab_quit') {
                        this[tag].h$.collect("robotCode", 998)
                    } else if (this.vue.util$.toJson$(letter).cmd === "update_robot_code_lab_start") {
                        this[tag].h$.collect("robotCode", 2)
                    } else if (this.vue.util$.toJson$(letter).cmd === 'start_block') {
                        const packageLetter = this.vue.util$.toJson$(letter)
                        const randomId = ((packageLetter.data && packageLetter.data.requestId) || eventName)
                        const callBack = this[tag].promisePool[randomId]
                        typeof callBack === 'function' && callBack(packageLetter)
                    } else if (this.vue.util$.toJson$(letter).cmd === "get_mc_info") {
                        const macInfo = this.vue.util$.toJson$(letter)
                        this.assignment(tag, { versionConfig: macInfo.data }, 'store')
                        this.vue.$store.commit('webVersion', macInfo.data.webVersion)
                    } else if (this.vue.util$.toJson$(letter).status && this.vue.util$.toJson$(letter).status.code == 10002) {
                        const cmd = this.vue.util$.toJson$(letter).cmd;
                        const currentVersion = this.vue.$store.state.currentVersion
                        if(["clone_project", "add_project", "clone_sample_project", "import_project"].includes(cmd) && currentVersion === "student"){
                            this.vue.$confirm(`
                                <div class="tip-icon">
                                    <svg width="150" height="150">
                                        <use xlink:href="#codelab-project-unsaved"></use>
                                    </svg>
                                </div> ${this.vue.$t("popper_title.login_limit_content")}`, this.vue.$t("popper_title.login_limit_title"), {
                                center: true,
                                showClose: false,
                                closeOnClickModal: true,
                                closeOnPressEscape: false,
                                distinguishCancelAndClose: true,
                                dangerouslyUseHTMLString: true,
                                showCancelButton: false,
                                confirmButtonClass: "codelab-button btn",
                                confirmButtonText: this.vue.$t('popper_title.login_limit_confirm'),
                                customClass: "codelab-important-tip project-unsaved",
                            })
                        } else if(cmd === "login"){
                            this[tag].h$.collect("socketCode", 10002)
                        }
                    }
                    return
                }
                if (eventName === 'ws.pong') return
                const packageLetter = this.vue.util$.toJson$(letter)

                const randomId = ((packageLetter.data && packageLetter.data.requestId) || eventName)
                const callBack = this[tag].promisePool[randomId]
                const sId = packageLetter.sid || ""

                if (!this[tag].queue[randomId] && !sId) {
                    return typeof callBack === 'function' && callBack(packageLetter)
                }

                this.expressLetter({ packageLetter, tag, eventName })
            })
        })
    }

    destroy (tag) {
        if (!this[tag]) {
            this[tag] = null
            return
        }
        this.close(tag)
        this[tag] = null
    }

    close (tag) {
        if (!this[tag] || !this[tag].h$) return
        
        this[tag].websocket.close(1000, 'client') 
    }

    assignment (tag, update, target) {
        target
            ? Object.assign(this[tag][target], update)
            : Object.assign(this[tag], update)
        return { nextTo: this.next() }
    }
    examination (tag) {
        return this[tag].websocket.readyState !== 1
    }
    next () {
        return Promise.resolve(this)
    }
    break () {
        return Promise.reject(this)
    }
}
